import { api } from '@/api/client';

const localKey = (userId: string) => `ims.v2.favorites.${userId}`;
const MODULES = new Set(['orders', 'shipments', 'exceptions', 'purchase', 'inventory', 'settlements', 'reports', 'taobao', 'products', 'customers', 'settings']);

function valid(value: unknown): value is string[] {
  return Array.isArray(value) && value.length <= 8 && new Set(value).size === value.length
    && value.every((key) => typeof key === 'string' && MODULES.has(key));
}

export function localFavorites(userId: string): string[] | null {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(localKey(userId)) || 'null');
    return valid(parsed) ? parsed : null;
  } catch { return null; }
}

/** 生产只读包优先沿用本机设置；本地可写模式与账号设置同步。 */
export async function loadFavorites(userId: string): Promise<string[] | null> {
  const local = localFavorites(userId);
  if (import.meta.env.VITE_READONLY !== '0' && local) return local;
  try {
    const remote = await api.get<unknown>('/api/v2/me/favorites');
    return valid(remote) ? remote : local;
  } catch { return local; }
}

export async function saveFavorites(userId: string, keys: string[]): Promise<'synced' | 'local'> {
  if (!valid(keys)) throw new Error('常用模块最多 8 个，且不能重复。');
  try { localStorage.setItem(localKey(userId), JSON.stringify(keys)); } catch { /* continue with account sync */ }
  if (import.meta.env.VITE_READONLY !== '0') return 'local';
  try { await api.patch<string[]>('/api/v2/me/favorites', keys); return 'synced'; }
  catch { return 'local'; }
}
